import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
@Component({
    selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.members/view.scss */
/* src/app/page.members/view.scss: no such file or directory */`],
})
export class PageMembersComponent implements OnInit {
 constructor(@Inject( Service) public service: Service) {}
 public async ngOnInit(){ await this.service.init(); await this.service.auth.allow('/access'); }
}

export default PageMembersComponent;